<template>
  <div class="use-notice">
    <van-popup :value="show" class="use-notice-popup" :style="{height:'100cqh'}" position="bottom"  safe-area-inset-bottom
               @input="closeSetting">
      <div style="font-weight: bolder;color: var(--primary-color);display: flex;flex-direction: row;justify-content: space-between;align-items: center;padding: 10px 15px;border-bottom: 1px solid var(--border-color);width: 100%">
        <div class="icon-and-title"><i class="iconfont icon-about"></i>旅途向导者 用户协议</div>
      </div>
      <div  class="settine-content" style="overflow: auto">
      <user-agreement ></user-agreement>
      </div>
      <div v-if="!$store.state.isReadNoticeForUser" style="padding: .5em;background-color: var(--header-bg);width: 100%;display: flex;flex-direction: column;justify-content: flex-start;align-items: center;gap: .5em">
        <div style="font-size: .7em;color: var(--footer-color);">请仔细阅读并理解以上内容，继续使用本网站即表示您同意上述条款。</div>
        <van-button style="height: 2.5em;color: var(--bg-color) !important;" block type="primary" @click="useApplication" round>同意并继续</van-button>
      </div>
    </van-popup>


  </div>
</template>

<script>
import {HandleScroll} from "@/utils/mixin/handleScroll";
import {changeProperty} from "@/utils/global-config";
import {Dialog} from "vant";
import {LOCAL_STORAGE_KEY, SIZE} from "@/constant/Constants";
import EvanCell from "@/components/EvanCell.vue";
import EvanSwitch from "@/components/EvanSwitch.vue";
import ValidName from "@/utils/ValidName";
import ValidTel from "@/utils/ValidTel";
import UserAgreement from "@/views/agreement/UserAgreement.vue";

export default {
  name: "UseNoticeForUserPage",
  components: {UserAgreement, EvanSwitch, EvanCell},
  mixins: [HandleScroll],
  model: {  // 新增 model 配置
    prop: 'show',
    event: 'update'
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    },

  },
  computed: {

  },
  data() {
    return {
      useRedis: true,
      useAI: true,
      useThirdService:true
    };
  },
  methods: {
    useApplication() {
      changeProperty(this, undefined, 'isReadNoticeForUser', true);
    },
    closeSetting() {
      this.$emit('update', false)
    },
  }, mounted() {

  }, watch: {

  }
}
</script>

<style scoped lang="scss">
.use-notice-popup{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  & *:not(i) {
    font-family: Helvetica, 'Hiragino Sans GB', 'Microsoft Yahei', '微软雅黑', Arial, sans-serif !important;
  }
}

.settine-content {

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: .5em;
}
</style>
